import React from "react";

const ErrorLayout = () => {
  return <>ErrorLayout</>;
};

export default ErrorLayout;
